/**
 * AI 面板输入框上方的快捷动作按钮行 (产品 2026-06-22)。
 * 仅当顶部 OnboardingCarousel 没出来时显示, 给已经在对话中的用户一个常驻入口。
 * 卡片 + 按钮共用 onboardingCardsCatalog: 同一份 query/label, 同一套后端 gating。
 */
import React from 'react'
import { OnboardingCardItem } from './onboardingCardsCatalog'
import './OnboardingShortcutRow.scss'

interface OnboardingShortcutRowProps {
  /**
   * 已合并后端 query + 本地素材的完整卡列表。
   * 与 OnboardingCarousel 共用同一份 items, 保证两处展示同一套 query/顺序。
   */
  items: OnboardingCardItem[]
  /**
   * 点击某个按钮 → 把对应预设问题发到会话。
   * 参数: (query, cardLabel, index1Based) — cardLabel 给神策 string2(本周拍照排行 等,
   * 与轮播卡同口径; 注意不是按钮上显示的 shortcutLabel), index 给 number1。
   */
  onShortcutClick: (
    query: string,
    cardLabel: string,
    index1Based: number
  ) => void
  /** disabled 时不响应点击 (例如上一轮还在 SSE 流式中) */
  disabled?: boolean
}

const OnboardingShortcutRow: React.FC<OnboardingShortcutRowProps> = ({
  items,
  onShortcutClick,
  disabled
}) => {
  if (items.length === 0) return null

  return (
    <div className="ai-photo-jun-panel__shortcut-row">
      {items.map((item, i) => {
        return (
          <button
            key={item.key}
            type="button"
            className="ai-photo-jun-panel__shortcut-btn"
            onClick={() => {
              if (disabled) return
              // 第二参传 cardLabel(给埋点 string2), 按钮显示仍用 shortcutLabel(见下方 span)
              onShortcutClick(item.query, item.cardLabel, i + 1)
            }}
            disabled={disabled}
            title={item.shortcutLabel}
          >
            {/* 2026-06-23 产品要求去掉前置图标, 只留精简文案 */}
            <span className="ai-photo-jun-panel__shortcut-label">
              {item.shortcutLabel}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default OnboardingShortcutRow
